document.addEventListener('DOMContentLoaded', function () {

  // Add to Cart Logic
  const cartButtons = document.querySelectorAll('.ciwt-add');

  cartButtons.forEach(button => {
    button.addEventListener('click', function () {
      const variantId = this.dataset.vid;
      const msg = this.closest('.ciwt-btns').querySelector('.ciwt-msg');

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const alreadyInCart = cart.items.find(
            item => item.id == variantId
          );

          if (alreadyInCart) {
            msg.style.display = 'block';

            setTimeout(() => {
              msg.style.display = 'none';
            }, 5000);

            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(() => {
            window.location.href = '/cart';
          });
        })
        .catch(err => console.error(err));
    });
  });


  // Scroll / Redirect Logic
  const actionButtons = document.querySelectorAll(".js-dynamic-action");

  actionButtons.forEach(button => {
    button.addEventListener("click", function (e) {
      const targetSelector = this.dataset.target;
      const href = this.getAttribute("href");

      // Scroll
      if (targetSelector && targetSelector.trim() !== "") {
        const target = document.querySelector(targetSelector);

        if (target) {
          e.preventDefault();

          target.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });

          return;
        }
      }

      // Redirect
      if (href && href !== "javascript:void(0)") {
        window.location.href = href;
      }
    });
  });

});